/**
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const NatObj = require('../types/NatObj')
const kernel = require('../kernel/kernel')
const CElementGraphique = require('./CElementGraphique')
const CListeObjets = require('./CListeObjets')
const CValeur = require('./CValeur')
const CSousListeObjets = require('./CSousListeObjets')
module.exports = CLieuObjetAncetre

/**
 * Classe ancêtre de tous les lieux d'objets.
 * @constructor
 * @extends CElementGraphique
 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
 * @param {CImplementationProto} impProto : null ou la liste propriétaire.
 * @param {Boolean} estElementFinal : true si élément final de construction.
 * @param {mtg32.Couleur} couleur : La couleur de l'objet.
 * @param {Booelan} masque : true si l'objet est masqué
 * @param {CElementGraphique} elementAssocie : L'objet qui laisse une trace.
 * @param {CValeur} nombreTraces : Le nombre d'objets pour la trace (dynamique).
 * @returns {CLieuObjetAncetre}
 */
function CLieuObjetAncetre (listeProprietaire, impProto, estElementFinal, couleur,
    masque, elementAssocie, nombreTraces) {
  if( arguments.length !== 0){
    if (arguments.length === 1) CElementGraphique.call(this, listeProprietaire);
    else {
      CElementGraphique.call(this, listeProprietaire, impProto, estElementFinal, couleur, true,
        0, 0, masque,"",2,0,0);
      this.elementAssocie = elementAssocie;
      this.nombreTraces = nombreTraces;
      this.listeCopiesObjet = new CListeObjets(listeProprietaire.uniteAngle, listeProprietaire.pointeurLongueurUnite);
    }
    this.listeElementsAncetres = new CSousListeObjets();
  }
}
CLieuObjetAncetre.prototype = new CElementGraphique();
CLieuObjetAncetre.prototype.constructor = CLieuObjetAncetre;
CLieuObjetAncetre.prototype.superClass = "CElementGraphique";
CLieuObjetAncetre.prototype.className = "CLieuObjetAncetre";

CLieuObjetAncetre.nombreMaxiPourLieuObjet = 100000;
CLieuObjetAncetre.prototype.setClone = function(ptel) {
  CElementGraphique.prototype.setClone.call(this,ptel);
  for (var i = 0; i < this.listeCopiesObjet.longueur(); i++) {
    var elb1 = this.listeCopiesObjet.get(i);
    var elb2 = ptel.listeCopiesObjet.get(i);
    elb1.setClone(elb2);
  }
};
CLieuObjetAncetre.prototype.positionne = function(infoRandom, dimfen) {
  CElementGraphique.prototype.positionne.call(this, infoRandom, dimfen);
  this.nombreTraces.positionne(infoRandom, dimfen);
  this.existe = this.existe && this.nombreTraces.existe;
};
CLieuObjetAncetre.prototype.metAJour = function() {
  this.prepareListeCopiesObjet();
  this.donneCouleur(this.couleur);
};
CLieuObjetAncetre.prototype.nombreObjetsPourLieuObjet = function(){
  if (!this.nombreTraces.existe) return kernel.MAX_VALUE;
  var d = Math.round(this.nombreTraces.rendValeur())* Math.round(this.elementAssocie.nombreObjetsPourLieuObjet());
  if ((d < 0) || (d > kernel.MAX_VALUE)) d = kernel.MAX_VALUE;
  return d;
};
CLieuObjetAncetre.prototype.initialisePourDependance = function() {
  CElementGraphique.prototype.initialisePourDependance.call(this);
  this.nombreTraces.initialisePourDependance();
};
CLieuObjetAncetre.prototype.prepareListeCopiesObjet = function() {
  // Il faut créer la liste des éléments dont dépend le point à tracer
  // Pour cette liste, on fait pointer la longueur unité éventuelle sur la liste mère
  this.listeCopiesObjet.retireTout();
  var nbt = Math.round(this.nombreTraces.rendValeur());
  if ((nbt >=2) && (nbt <= CLieuObjetAncetre.nombreMaxiPourLieuObjet)) {
    this.listeCopiesObjet.ajouteClonesDe(this.elementAssocie, nbt);
    // Ligne suivante ajoutée version 2.0
    // Nécessaire pour les lieux de lieux d'objets car ce type d'objet mainient une liste
    // qui est instanciée de façon dynamique
    this.listeCopiesObjet.metAJour();
  }
  // La ligne suivante sert à donner aux objets clonés servant à la trace la couleur du lieu
  // d'objet
  this.donneCouleur(this.couleur);
};

CLieuObjetAncetre.prototype.depDe = function(p) {
  return CElementGraphique.prototype.depDe.call(this, p) ||
    this.elementAssocie.depDe(p) || this.nombreTraces.depDe(p);
};
CLieuObjetAncetre.prototype.dependDePourBoucle = function(p) {
  return ((p === this) || this.elementAssocie.dependDePourBoucle(p) || this.nombreTraces.dependDePourBoucle(p));
};
CLieuObjetAncetre.prototype.cache = function() {
  CElementGraphique.prototype.cache.call(this);
  for(var i = 0; i < this.listeCopiesObjet.longueur();i++){
    this.listeCopiesObjet.get(i).cache();
  }
};
CLieuObjetAncetre.prototype.montre = function() {
  CElementGraphique.prototype.montre.call(this);
  for(var i = 0; i < this.listeCopiesObjet.longueur();i++){
    this.listeCopiesObjet.get(i).montre();
  }
};
CLieuObjetAncetre.prototype.createg = function(svg, couleurFond, transparence){
  var gcree;
  var g = kernel.cens("g",{
    "pointer-events" : "none"
  });
  for (var i = 0; i < this.listeCopiesObjet.longueur(); i++) {
    var elg = this.listeCopiesObjet.get(i);
    if (elg.hasg(false)) {
      gcree = elg.createg(svg, couleurFond, transparence);
      elg.g = gcree;
      g.appendChild(gcree); // A revoir
    }
    // g vide si l'objet n'existe pas
  }
  return g;
};
/**
 * Spécial JvaScript : on mémorise le nombre d'objets tracés.
 * Au prochain update, si le nombre d'objets est le même on n'appelera pas createg
 * mais updateg pour chaque objet de la liste d'objest dupliqués.
 */
CLieuObjetAncetre.prototype.trace = function(svg, couleurFond, transparence) {
  var g = this.createg(svg, couleurFond, transparence);
  g.setAttribute("id",this.id);
  svg.appendChild(g);
  this.g = g;
};
CLieuObjetAncetre.prototype.update = function(svg, couleurFond, transparence) {
  var oldg = this.g;
  var g = this.createg(svg, couleurFond, transparence);
  svg.replaceChild(g, oldg);
  g.setAttribute("id",this.id);
  this.g = g;
};
CLieuObjetAncetre.prototype.getNature = function() {
  return NatObj.NLieuObjet;
};
CLieuObjetAncetre.prototype.donneCouleur = function(coul) {
  this.couleur = coul;
  this.color = coul.rgb(); //
  for (var i = 0; i < this.listeCopiesObjet.longueur(); i++) this.listeCopiesObjet.get(i).donneCouleur(coul);
};
CLieuObjetAncetre.prototype.ajusteListeCopieObjets = function() {
  var nbt = Math.round(this.nombreTraces.rendValeur());
  var ancien = this.listeCopiesObjet.longueur();
  if (nbt < ancien)
    for (var i = 0; i < ancien - nbt; i++) this.listeCopiesObjet.remove(this.listeCopiesObjet.longueur()-1);
  else {
    this.listeCopiesObjet.ajouteClonesDe(this.elementAssocie, nbt - ancien);
    this.listeCopiesObjet.metAJour();
    this.donneCouleur(this.couleur);
  }
  this.listeProprietaire.recreeListesCopiesLieuxObjetsDependantDe(this);
};
CLieuObjetAncetre.prototype.recreeListeCopieObjets = function() {
  var nbt = Math.round(this.nombreTraces.rendValeur());
  this.listeCopiesObjet.retireTout();
  this.listeCopiesObjet.ajouteClonesDe(this.elementAssocie, nbt);
  this.listeCopiesObjet.metAJour();
  this.donneCouleur(this.couleur);
};
CLieuObjetAncetre.prototype.read = function(inps, list){
  CElementGraphique.prototype.read.call(this,inps,list);
  var ind1 = inps.readInt();
  this.elementAssocie = list.get(ind1,"CElementGraphique");
  this.nombreTraces = new CValeur();
  this.nombreTraces.read(inps, list);
  // Il faut créer la liste des éléments dont dépend le point à tracer
  // Pour cette liste, on fait pointer la longueur unité éventuelle sur la liste mère
  // Ligne suivante revue version 3.4.2
  // listeElementsAncetres = new CListeObjets(list.uniteAngle, list.pointeurLongueurUnite);
  if (list.className !== "CPrototype") {
    this.listeCopiesObjet = new CListeObjets(list.uniteAngle, list.pointeurLongueurUnite);
    // Comme le nombre d'objets est dynamique on ne peut pas savoir au chargement combien il y en a.
    //On laisse la liste vide et cela sera mis à jour lorsque positionne() sera appelé
    this.donneCouleur(this.couleur);
  }
};
CLieuObjetAncetre.prototype.write = function(oups, list) {
  CElementGraphique.prototype.write.call(this, oups, list);
  var ind1 = list.indexOf(this.elementAssocie);
  oups.writeInt(ind1);
  this.nombreTraces.write(oups, list);
}
CLieuObjetAncetre.prototype.setReady4MathJax = function() {
  /*
  for(var i = 0; i < this.listeCopiesObjet.longueur();i++){
    this.listeCopiesObjet.get(i).setReady4MathJax();
  }
  */
  this.listeCopiesObjet.setReady4MathJax();
};
CLieuObjetAncetre.prototype.setReady4MathJaxUpdate = function() {
  /*
    for(var i = 0; i < this.listeCopiesObjet.longueur();i++){
    this.listeCopiesObjet.get(i).setReady4MathJax();
  }
  */
   this.listeCopiesObjet.setReady4MathJax();
};
CLieuObjetAncetre.prototype.chaineDesignation = function() {
  return "desLieuObjet";
};
